enum ClientLogOutOptionsEnum {
  account_settings = "アカウント設定",
  privacy_policy = "プライバシーポリシー",
  company_profile = "運営会社",
  terms_of_service = "利用規約",
  manual = "マニュアル",
  log_out = "ログアウト",
}
type IClientLogOutOptions = {
  name: string;
  value: string;
};

const ClientLogOutOptions: IClientLogOutOptions[] = Object.entries(ClientLogOutOptionsEnum).map(([name, value]) => ({
  name,
  value,
}));
export { ClientLogOutOptionsEnum, ClientLogOutOptions };
